import { WalletType } from '~/shared';

import { Currency } from '../Currency';
import { StyledListHorizontal } from './CurrencyList.styled';

export interface IPlayerCurrencies {
	type: WalletType;
	value: number;
}

interface CurrencyListProps extends React.HTMLAttributes<HTMLDivElement> {
	currencies: IPlayerCurrencies[];
}

const CurrencyList = ({ currencies, ...props }: CurrencyListProps) => {
	return (
		<StyledListHorizontal {...props}>
			{currencies.map(({ type, value }, index) => {
				return <Currency key={`currency#${index}`} type={type} value={value} />;
			})}
		</StyledListHorizontal>
	);
};

export { CurrencyList };
